import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "290",
  "slug": "spot-saudi-arabia-from-satellite-imagery",
  "title": "How to Recognise Saudi Arabia in Satellite Images",
  "excerpt": "Saudi Arabia has a long Red Sea coast, elevated terrain in the west, and broad dry interior regions.",
  "date": "2026-05-03",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/saudi-arabia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Saudi Arabia has a long Red Sea coast, elevated terrain in the west, and broad dry interior regions. In detailed imagery, centre-pivot irrigation can appear as circles within the desert. The Empty Quarter occupies much of the southeast of the Arabian Peninsula."
    },
    {
      "type": "heading",
      "text": "The Red Sea margin and the interior deserts"
    },
    {
      "type": "paragraph",
      "text": "Compare the western highlands near the Red Sea with the broad interior. The regional overview is too coarse to identify individual farms; use a closer image for that task."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Circular irrigation is used in many countries, and dunes extend beyond Saudi Arabia. Oman, the UAE, and other neighbours share dry landscapes. Check the mountain front or coastline as well as the field pattern."
    }
  ],
  "imageAlt": "Saudi Arabia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
